import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ForgotPassword = ({ extraClass, forgotStyle }) => {
    return (
        <div className={`newsletter-area ${forgotStyle}`}>
            <div className="container">
                <div className={`row row--0 newsletter-wrapper align-items-center ${extraClass}`}>
                    <div className="col-lg-4">
                        <div className="newsletter-section-title">
                            <h3 className="title">Forgot Your Password?</h3>
                            <p className="description">Enter your email address to reset your password.</p>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <form className="rn-newsletter mt_md--20 mt_sm--20" action="#">
                            <div className="form-group">
                                <input type="email" placeholder="Email Address" required />
                            </div>
                            <div className="form-group">
                                <button className="btn-default">Send Reset Link</button>
                            </div>
                            <div className="form-group mt--10">
                                <p className="description mb--0">
                                    Remember your password? <Link to="/login" className="text-link">Back to Login</Link>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
